import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
@Component
export default class NumberInput extends Vue {
    public title: string = 'NumberInput';
    @Prop({ default: 0 })
    public default!: number;
    public data: number = 0;
    @Watch('data', { immediate: true, deep: true })
    public onDataUpdate(val: any, oldVal: any) {
        if (!isNaN(val)) {
            this.$emit('numberChange', parseInt(val, 10));
        }
    }
    public created() {
        this.data = this.default;
    }
    public minus() {
        if (this.data <= 0) {
            return;
        }
        this.data--;
    }
    public add() {
        this.data++;
    }
}
